import { useEffect } from "react";
import { isObject } from "underscore";

import { updateWorkingThemePack } from "store/actions/admin/create-event";
import { useAppDispatch, useTypedSelector } from "store/reducers/use-typed-selector";
import { getCreateProjectUrl } from "utils/utils";

const useListenForPreviewOverrides = () => {
	const workingEventUuid = useTypedSelector(state => state.CreateEventReducer.workingEvent?.uuid);

	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!workingEventUuid) {
			return;
		}

		// listen for incoming post messages to override the preview
		const handleMessage = (event: MessageEvent) => {

			const projectOverviewUrl = getCreateProjectUrl();

			// validate the message is coming from project overview
			if (event.origin !== projectOverviewUrl) {
				console.warn(`Received message from ${event.origin}, but expected origin is ${projectOverviewUrl}. Ignoring.`);
				return;
			}

			if (event.data && event.data.type === 'PREVIEW_TEMPLATES_OVERRIDES') {
				const payload = event.data.payload;
				if (!isObject(payload)) {
					console.error('Invalid payload received for preview override:', event.data.payload);
					return;
				}
				const projectUuid = payload.previewTemplateUuid;
				const overrides = payload.overrides;
				if (!projectUuid || !overrides) {
					console.error('Invalid payload structure for preview override:', payload);
					return;
				}
				if (projectUuid !== workingEventUuid) {
					console.warn(`Received preview override for project ${projectUuid}, but current working event is ${workingEventUuid}. Ignoring.`);
					return;
				}

				const themeMode = overrides?.themeMode;
				const themePack = overrides?.themePack;

				// override workingEvent theme data with payload in redux only
				dispatch(updateWorkingThemePack({ themePack: themePack || null, mode: themeMode || null }));
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};

	}, [dispatch, workingEventUuid]);
};

export default useListenForPreviewOverrides;
